/**
 * Must be kept in sync with the $grid-breakpoints in theme.scss
 */
export enum BootstrapBreakpoint {
  XS = 0,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1260,
  XXL = 1500,
  XXXL = 1800,
  XXXXL = 2100,
}
